/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LanguageCto } from '../../models/language-cto';

export interface GetAvailableForPi2$Json$Params {
}

export function getAvailableForPi2$Json(http: HttpClient, rootUrl: string, params?: GetAvailableForPi2$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<LanguageCto>>> {
  const rb = new RequestBuilder(rootUrl, getAvailableForPi2$Json.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<LanguageCto>>;
    })
  );
}

getAvailableForPi2$Json.PATH = '/aphealthcheck/v1/languages';
